export enum POPUP_TYPE {
    ALERT, // only confirm button
    CONFIRM, // confirm & cancel button
    LEAVE_ALERT, // only confirm button & Route to Thanks Page after Confirm
    THANK_ALERT, // only confirm button & Route to Thanks Page after Confirm & Not clear data e.g. LS connection fail
    LOGOUT_CONFIRM, // confirm & cancel button
    POPUP, // no button
}

export enum POPUP_CONFIRM_ACTION {
    NONE,
    RETRY,
}

export enum StateMsgType {
    betInfo_Normal,
    betInfo_Success,
    betInfo_Fail,
    betInfo_Warning,
}

export const MESSAGE_TIME = 4 * 1000;
export const BETTING_TIME = 2 * 1000;
